import React, { useState } from 'react';
import classNames from 'classnames';
import queryString from 'query-string';
import { ReactComponent as BeeHeroIcon } from '../../images/BeeHeroIcon.svg';
import MainHoc from '../MainHoc';
import { PuffLoader } from 'react-spinners';
import { Page, Title } from '../../shared';
import styles from '../Main.module.scss';
import LoginForm from '../Login/LoginForm';
import PropTypes from 'prop-types';
import { titleText } from '../textConsts';
import { loginToYourAccountText } from '../../shared/consts';
import useMediaQuery from '../../shared/hooks/useMediaQuery';
import { isMobileQuery } from '../../shared/MediaQuery/mediaQueryUtils';

export const UserInvite = (props) => {
    const isMobile = useMediaQuery(isMobileQuery);
    const [loading, setLoading] = useState(false);
    const token = props.match.params.token;
    const email = props.match.params.email;

    const appRedirection = queryString.parse(props.location.search).to;
    const queryParams = props.location.search;

    return (
        <MainHoc>
            <div className={classNames({ [styles.content]: !isMobile })}>
                {loading && (
                    <div
                        className={classNames(styles.backdrop, {
                            [styles.full_width]: isMobile
                        })}
                    >
                        <PuffLoader color={'#ffcc2e'} size={100} />
                    </div>
                )}

                <Page>
                    <Page.Section>
                        <Title
                            small
                            subtitleMargin
                            flex
                            title={titleText}
                            svg={BeeHeroIcon}
                            subtitle={loginToYourAccountText}
                            iconSize={40}
                        />
                        <LoginForm
                            appRedirection={appRedirection}
                            setLoading={setLoading}
                            queryParams={queryParams}
                            inviteForm
                            email={email}
                            token={token}
                            props={props}
                        />
                    </Page.Section>
                </Page>
            </div>
        </MainHoc>
    );
};

UserInvite.propTypes = {
    match: PropTypes.object,
    location: PropTypes.object
};
